import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Select,
  MenuItem,
  TextField,
  Typography,
  Tabs,
  Grid,
  Tab,
  FormControl,
  Box,
  Drawer,
  InputAdornment,
  Tooltip,
  CircularProgress,
  IconButton,
  Avatar,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import InvitationSent from "./InvitationSent";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import moment from "moment";
import { fetchDepartmentDetails } from "../../../../../containers/actions/userActions";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { fetchTeamAssociates } from "../../../containers/actions/common/teamMemberAction";
import InviteTeamMember from "./inviteTeamMember";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ViewDetails from "./viewDetails";

import { FETCH_TEAM_ASSOCIATES_LOADING } from "../../../containers/actions/types";
import {
  ChevronLeft,
  ChevronRight,
  Clear,
  Refresh,
  Search,
} from "@material-ui/icons";
import usePrevious from "../../helpers/previousProps";
import { getFeaturesAccess } from "../../../containers/actions/common/accessControl";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
  },
  active: {
    backgroundColor: "#2e7d32",
    width: "7rem",
    color: "white",
    padding: "5px 10px",
    borderRadius: "5px",
    textAlign: "center",
  },
  inactive: {
    backgroundColor: "#b71c1c",
    width: "7rem",
    color: "white",
    padding: "5px 10px",
    borderRadius: "5px",
    textAlign: "center",
  },
  searchField: {
    marginBottom: theme.spacing(2),
  },
  upload: {
    background:
      "transparent linear-gradient(251deg, #173072 0%, #301232 100%) 0% 0% no-repeat padding-box;",
    color: "white",
    textTransform: "none",
    borderRadius: "2rem",
    // marginRight: 20,
    padding: "5px 20px",
    "&:hover": {
      backgroundColor: "green",
      background: "green",
      color: "white",
    },
  },
  drawerPaper: {
    width: "33vw",
    minWidth: "600px",
  },
  multipleLogo: {
    border: "1px solid #7d7c7c",
    borderRadius: "4px",
    padding: "0.3rem",
    height: "inherit",
    marginLeft: "0.5rem",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "black",
      color: "white",
      border: "1px solid #FFF",
    },
  },
  drawerPaper: {
    width: "33vw",
    minWidth: "600px",
  },
}));

const TeamDashboard = () => {
  const classes = useStyles();
  const location = useLocation();
  // BCM-972: "Update User Permissions" on the Planned MFG Start Date Edit Access
  // Requested notification links here with ?search=<requester name>.
  const searchFromQuery = new URLSearchParams(location.search || "").get("search") || "";
  // const debounceRef = useRef(null);
  const [search, setSearch] = useState("all");
  const [view, setView] = useState("TeamMembers");
  const [inviteDrawer, setInviteDrawer] = useState(false);
  const [status, setStatus] = useState("all");
  const [profileData, setProfileData] = useState({ role: "All" });
  const [departmentID, setDepartmentID] = useState(0);
  const [paginatedData, setPaginatedData] = useState([]);
  const [collaboratorRoleID, setCollaboratorRoleID] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [teamMembersList, setTeamMembersList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [showPagination, setShowPagination] = useState(false);
  const [ViewDetailsDrawer, setViewDetailsDrawer] = useState(false);
  const [user, setUser] = useState({});
  const dispatch = useDispatch();

  const teamMembersData = useSelector((state) => {
    return state?.pcmp?.common?.teamMembers?.teamMembersDetails;
  });

  const prevTeamMembersData = usePrevious(teamMembersData);

  const teamMembersListLoading = useSelector((state) => {
    return state?.pcmp?.common?.teamMembers?.teamMembersDetailsLoading || {};
  });

  const fetchDepartmentsList = useSelector((state) =>
    state?.user?.fetchDepartments?.data
      ? state?.user?.fetchDepartments.data
      : []
  );

  //Screen Access
  const screenAccess = useSelector(
    (state) =>
      state.pcmp.common.accessControl.screensAccess.data.manageTeamMembers
  );
  // console.log("🚀 ~ TeamDashboard ~ screenAccess:", screenAccess);

  const featuresAccess = useSelector(
    (state) => state.pcmp.common.accessControl.featuresAccess.manageTeamMembers
  );
  // console.log("🚀 ~ TeamDashboard ~ featuresAccess:", featuresAccess);

  useEffect(() => {
    if (screenAccess?.screenAccess && !featuresAccess)
      dispatch(getFeaturesAccess(screenAccess?.screenId, "manageTeamMembers"));
    // We can pick up DS screen Id from access screensAccess.data.deliverySchedule.screenId
  }, [dispatch, screenAccess, featuresAccess]);

  useEffect(() => {
    dispatch(fetchDepartmentDetails());
    sessionStorage.clear();
  }, []);

  useEffect(() => {
    setSearch(searchFromQuery);
    dispatch({
      type: FETCH_TEAM_ASSOCIATES_LOADING,
      payload: true,
    });
    dispatch(
      fetchTeamAssociates({
        searchString: searchFromQuery || search,
        status: status,
        departmentID: departmentID,
        collaborator_role_id: collaboratorRoleID,
        // pageNumber: currentPage,
        // pageSize: rowsPerPage,
      })
    );
  }, []);

  useEffect(() => {
    if (
      JSON.stringify(teamMembersData) !== JSON.stringify(prevTeamMembersData)
    ) {
      setTeamMembersList(teamMembersData);
    }
  }, [teamMembersData, prevTeamMembersData]);

  useEffect(() => {
    const activeCount =
      teamMembersList?.data?.filter((item) => item.account_status === "Active")
        .length || 0;
    const inactiveCount =
      teamMembersList?.data?.filter(
        (item) => item.account_status === "Inactive"
      ).length || 0;

    let newTotalRecords = activeCount + inactiveCount;
    setTotalRecords(newTotalRecords);

    setShowPagination(newTotalRecords > 0); // Always show pagination if there are records

    const pages = Math.ceil(newTotalRecords / rowsPerPage); // Calculate number of pages
    setTotalPages(pages);

    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = Math.min(startIndex + rowsPerPage, newTotalRecords);

    // Slice the data based on pagination
    let newPaginatedData = [];
    if (
      Array.isArray(teamMembersList?.data) &&
      teamMembersList?.data.length > 0
    ) {
      const filteredData = teamMembersList?.data?.filter(
        (member) =>
          member.account_status !== "Pending" && member.account_status !== null
      );
      newPaginatedData = filteredData?.slice(startIndex, endIndex);
    }

    setPaginatedData(newPaginatedData);
  }, [teamMembersList, rowsPerPage, currentPage]);

  const activeRecords =
    teamMembersList?.data?.filter((item) => item.account_status === "Active")
      .length || 0;
  const inactiveRecords =
    teamMembersList?.data?.filter((item) => item.account_status === "Inactive")
      .length || 0;

  const totalRecordsOfTeamMembers = activeRecords + inactiveRecords;

  const pendingRecords =
    teamMembersList?.data?.filter((item) => item.account_status === "Pending")
      .length || 0;

  const UserAvatar = ({ profileImage, profileName }) => {
    return (
      <Box display="flex" alignItems="center">
        <Avatar
          src={profileImage} // Use the Base64 string here
          alt={profileName} // Optional: Alt text for accessibility
          style={{ marginRight: "8px" }} // Adjust spacing if needed
        />
      </Box>
    );
  };

  const handleDetailView = (user) => {
    setUser(user);
    setViewDetailsDrawer(true);
    // fetchDepartmentsList
  };

  const handleSearch = () => {
    setCurrentPage(1);
    dispatch({
      type: FETCH_TEAM_ASSOCIATES_LOADING,
      payload: true,
    });
    dispatch(
      fetchTeamAssociates({
        searchString: search,
        status: status,
        departmentID: departmentID,
        collaborator_role_id: collaboratorRoleID,
        // pageNumber: currentPage,
        // pageSize: rowsPerPage,
      })
    );
  };

  const handleClearSearch = () => {
    setCurrentPage(1);
    setSearch("");
    dispatch({
      type: FETCH_TEAM_ASSOCIATES_LOADING,
      payload: true,
    });
    dispatch(
      fetchTeamAssociates({
        searchString: "all",
        // pageNumber: currentPage,
        // pageSize: rowsPerPage,
        status: status,
        departmentID: departmentID,
        collaborator_role_id: collaboratorRoleID,
      })
    );
  };

  const handleStatusChange = (event) => {
    const newStatus = event.target.value;
    setStatus(newStatus);
    setCurrentPage(1); // Reset to first page when filter changes
    dispatch({
      type: FETCH_TEAM_ASSOCIATES_LOADING,
      payload: true,
    });
    dispatch(
      fetchTeamAssociates({
        searchString: search,
        status: newStatus,
        departmentID: departmentID,
        collaborator_role_id: collaboratorRoleID,
        // pageNumber: currentPage,
        // pageSize: rowsPerPage,
      })
    );
  };

  const handleClearFilters = () => {
    setStatus("all");
    setSearch("");
    setRowsPerPage(5);
    setCurrentPage(1);
    setDepartmentID(0);
    setCollaboratorRoleID(0);
    setProfileData({ role: "All" });
    dispatch({
      type: FETCH_TEAM_ASSOCIATES_LOADING,
      payload: true,
    });
    dispatch(
      fetchTeamAssociates({
        searchString: "all",
        status: "all",
        departmentID: 0,
        collaborator_role_id: 0,
        // pageNumber: 1,
        // pageSize: 5,
      })
    );
  };

  const handleRefresh = () => {
    dispatch({
      type: FETCH_TEAM_ASSOCIATES_LOADING,
      payload: true,
    });
    dispatch(
      fetchTeamAssociates({
        searchString: search,
        status: status,
        departmentID: departmentID,
        collaborator_role_id: collaboratorRoleID,
        // pageNumber: currentPage,
        // pageSize: rowsPerPage,
      })
    );
  };

  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = event.target.value;
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
    // dispatch(
    //   fetchTeamAssociates({
    //     searchString: search,
    //     status: status,
    //     departmentID: departmentID,
    //     collaborator_role_id: collaboratorRoleID,
    //     pageNumber: currentPage,
    //     pageSize: newRowsPerPage,
    //   })
    // );
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    // dispatch({
    //   type: FETCH_TEAM_ASSOCIATES_LOADING,
    //   payload: true,
    // });
    // dispatch(
    //   fetchTeamAssociates({
    //     searchString: search,
    //     status: status,
    //     departmentID: departmentID,
    //     collaborator_role_id: collaboratorRoleID,
    //     pageNumber: newPage,
    //     pageSize: rowsPerPage,
    //   })
    // );
  };

  const handleTabChange = (event, newValue) => {
    setView(newValue);
    setDepartmentID(0);
    setCollaboratorRoleID(0);
    setProfileData({ role: "All" }); // Reset department-role to "All"
    dispatch({
      type: FETCH_TEAM_ASSOCIATES_LOADING,
      payload: true,
    });
    dispatch(
      fetchTeamAssociates({
        searchString: "all",
        status: status,
        departmentID: 0,
        collaborator_role_id: 0,
        // pageNumber: currentPage,
        // pageSize: rowsPerPage,
      })
    );
  };

  const getRoleOptions = () => {
    let options = [];
    if (!options.some((option) => option.displayName === "All")) {
      options.push({
        displayName: "All",
        departmentID: 0,
        collaborator_role_id: 0,
      });
    }
    fetchDepartmentsList.forEach((department) => {
      department.rolesList.forEach((role) => {
        options.push({
          displayName: `${department.departmentName} - ${role.role_name}`,
          departmentID: department.departmentID,
          collaborator_role_id: role.collaborator_role_id,
        });
      });
    });
    return options;
  };
  const roleOptions = getRoleOptions();

  // const roleOptions = useMemo(() => {
  //   let options = [];
  //   if (!options.some((option) => option.displayName === "All")) {
  //     options.push({
  //       displayName: "All",
  //       departmentID: 0,
  //       collaborator_role_id: 0,
  //     });
  //   }
  //   fetchDepartmentsList.forEach((department) => {
  //     department.rolesList.forEach((role) => {
  //       options.push({
  //         displayName: `${department.departmentName} - ${role.role_name}`,
  //         departmentID: department.departmentID,
  //         collaborator_role_id: role.collaborator_role_id,
  //       });
  //     });
  //   });
  //   return options;
  // }, [fetchDepartmentsList]);

  const handleRoleChange = (event) => {
    const selectedOption = roleOptions.find(
      (option) => option.displayName === event.target.value
    );
    const newDepartmentID = selectedOption?.departmentID || 0;
    const newCollaboratorRoleID = selectedOption?.collaborator_role_id || 0;

    setProfileData((prev) => ({
      ...prev,
      role: event.target.value,
    }));

    setDepartmentID(newDepartmentID);
    setCollaboratorRoleID(newCollaboratorRoleID);
    setCurrentPage(1); // Reset to first page when filter changes

    // if (debounceRef.current) {
    //   clearTimeout(debounceRef.current);
    // }

    // debounceRef.current = setTimeout(() => {

    dispatch({
      type: FETCH_TEAM_ASSOCIATES_LOADING,
      payload: true,
    });
    dispatch(
      fetchTeamAssociates({
        searchString: search,
        status: status,
        departmentID: newDepartmentID,
        collaborator_role_id: newCollaboratorRoleID,
        // pageNumber: 1,
        // pageSize: rowsPerPage,
      })
    );
    // }, 300);
  };

  const renderTeamMemberDetails = () => (
    <div>
      <Box
        style={{
          border: "1px solid #bdbdbd",
          padding: "1rem",
          // borderRadius: "0.5rem",
          paddingBottom: "1rem",
          marginTop: "2rem",
        }}
      >
        <Grid
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "end",
            flexDirection: "row",
          }}
        >
          <Grid
            item
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <Grid
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "10px",
                flexDirection: "column",
                marginTop: "1.5rem",
              }}
            >
              <Grid>
                <Typography style={{ fontWeight: "bold" }}>Search</Typography>
              </Grid>
              <Grid
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "row",
                }}
              >
                <Grid>
                  <TextField
                    placeholder="Search using full name"
                    variant="outlined"
                    size="small"
                    style={{ marginRight: 16, width: "13rem" }}
                    value={search}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow alphabets and single spaces only, no multiple spaces between words
                      const regex = /^[A-Za-z ]*$/;
                      if (regex.test(value)) {
                        // Remove multiple spaces and trim leading/trailing spaces
                        const formattedValue = value.replace(/\s{2,}/g, " ");
                        setSearch(formattedValue);
                      }
                    }}
                    onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          {search && (
                            <Tooltip title="Clear search" aria-label="clear">
                              <Clear
                                fontSize="small"
                                onClick={handleClearSearch}
                                style={{
                                  cursor: "pointer",
                                  color: "dimgray",
                                }}
                              />
                            </Tooltip>
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid>
                  <Button
                    variant="contained"
                    style={{
                      marginRight: "1rem",
                      borderRadius: "0.5rem",
                      textTransform: "none",
                      backgroundColor: "#286acf",
                      color: "#fff",
                    }}
                    onClick={handleSearch}
                  >
                    Search
                  </Button>
                </Grid>
              </Grid>
            </Grid>

            {/* ////////////   */}

            <Grid
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "10px",
                flexDirection: "column",
                marginTop: "1.5rem",
              }}
            >
              <Grid>
                <Typography style={{ fontWeight: "bold" }}>
                  Department - Role
                </Typography>
              </Grid>

              <Grid>
                <FormControl
                  variant="outlined"
                  size="small"
                  style={{ width: "13rem", marginRight: "1rem" }}
                >
                  <TextField
                    size="small"
                    select
                    variant="outlined"
                    placeholder="Choose option"
                    // className={classes.textfieldWidth}
                    onChange={handleRoleChange}
                    value={profileData.role || "all"}
                  >
                    {roleOptions.map((option) => (
                      <MenuItem
                        key={option.displayName}
                        value={option.displayName}
                      >
                        {option.displayName}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              </Grid>
            </Grid>

            <Grid
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "10px",
                flexDirection: "column",
                marginTop: "1.5rem",
              }}
            >
              <Grid>
                <Typography style={{ fontWeight: "bold" }}>Status</Typography>
              </Grid>

              <Grid>
                <FormControl
                  variant="outlined"
                  size="small"
                  style={{ width: "13rem", marginRight: "1rem" }}
                >
                  <TextField
                    size="small"
                    select
                    variant="outlined"
                    placeholder="Choose option"
                    onChange={handleStatusChange}
                    value={status}
                  >
                    <MenuItem value="all">All</MenuItem>
                    <MenuItem value="Active">Active</MenuItem>
                    <MenuItem value="Inactive">Inactive</MenuItem>
                  </TextField>
                </FormControl>
              </Grid>
            </Grid>

            <Grid
              style={{
                gap: "10px",
                marginTop: "4rem",
              }}
            >
              <Typography
                variant="caption"
                style={{
                  fontSize: 12,
                  color: "#0000ff",
                  cursor: "pointer",
                  textDecoration: "underline",
                  whiteSpace: "nowrap",
                }}
                className={classes.clearText}
                onClick={handleClearFilters}
              >
                Clear All Filter
              </Typography>
            </Grid>

            <Grid
              style={{
                gap: "10px",
                marginTop: "4rem",
                marginLeft: "1rem",
              }}
            >
              {/* <Button
                variant="contained"
                color="primary"
                // className={classes.search}
                style={{
                  borderRadius: "2rem",
                  textTransform: "none",
                  whiteSpace: "nowrap",
                }}
                // onClick={handleSearch} 
                disabled
              >
                Save Filters
              </Button> */}
            </Grid>
          </Grid>

          <Grid
            container
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <Grid
              item
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <Typography
                variant="body2"
                style={{ color: "gray", marginRight: "8px" }}
                className="last-synced-text"
              >
                {`Last synced @ ${moment(new Date()).format(
                  "HH:mm:ss; DD MMMM, YYYY"
                )}`}
              </Typography>
              <Grid>
                <Typography
                  variant="body2"
                  color="primary"
                  style={{
                    textDecoration: "underline",
                    fontStyle: "italic",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={handleRefresh}
                  className="refresh-button"
                >
                  Refresh
                  <Refresh
                    className="refresh-button svg"
                    color="primary"
                    fontSize="small"
                  />
                </Typography>
              </Grid>
            </Grid>

            <Grid
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                marginTop: "10px",
                width: "100%",
              }}
            >
              <React.Fragment className="per-page-box">
                <Typography
                  style={{
                    fontWeight: "bold",
                    marginRight: "4px",
                    whiteSpace: "nowrap",
                  }}
                >
                  PER PAGE
                </Typography>
                <FormControl variant="outlined" size="small">
                  <Select
                    value={rowsPerPage}
                    onChange={handleRowsPerPageChange}
                  >
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={15}>15</MenuItem>
                  </Select>
                </FormControl>
              </React.Fragment>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <TableContainer
        component={Paper}
        style={{
          borderLeft: "1px solid #bdbdbd",
          borderRight: "1px solid #bdbdbd",
          borderBottom: "1px solid #bdbdbd",
        }}
      >
        <div className="default-table-styles">
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Team Member</TableCell>
                <TableCell>Phone</TableCell>
                <TableCell>Employee Number</TableCell>
                <TableCell>Department - Role</TableCell>
                <TableCell>Status</TableCell>
                {localStorage?.roleName === "Admin" &&
                (localStorage?.departmentId === "null" ||
                  Number(localStorage?.getItem("departmentId")) === 1) &&
                featuresAccess?.viewTeamMemberDetails ? (
                  <TableCell>Action</TableCell>
                ) : (
                  <TableCell></TableCell>
                )}
                {/* <TableCell>
  {featuresAccess?.viewTeamMemberDetails && "Action"}
</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {teamMembersListLoading === true ? (
                <TableRow style={{ height: 150 }}>
                  <TableCell colSpan={12}>
                    <div style={{ textAlign: "center" }}>
                      <CircularProgress color="primary" thickness={7} />
                    </div>
                  </TableCell>
                </TableRow>
              ) : activeRecords === 0 && inactiveRecords === 0 ? ( // No records condition
                <TableRow>
                  <TableCell colSpan={12} align="center">
                    No records found
                  </TableCell>
                </TableRow>
              ) : paginatedData.length > 0 ? (
                paginatedData.map((member, index) => (
                  <TableRow key={index}>
                    <TableCell
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "0.3rem",
                      }}
                    >
                      <Grid>
                        <UserAvatar profileImage={member?.profile_pic} />
                      </Grid>
                      <Grid
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                        }}
                      >
                        <Typography>{member?.full_name || ""}</Typography>
                        <Typography variant="body2" color="textSecondary">
                          {member?.email_address || ""}
                        </Typography>
                      </Grid>
                    </TableCell>
                    <TableCell>
                      {!member?.phone_number ||
                      member?.phone_number?.trim() === "" ||
                      member?.phone_number?.toLowerCase() === "null"
                        ? ""
                        : (() => {
                            let phoneNumber = member.phone_number.trim();
                            if (phoneNumber.startsWith("+")) {
                              if (phoneNumber.startsWith("+91")) {
                                const restOfNumber = phoneNumber
                                  .substring(3)
                                  .replace(/\s+/g, "");
                                return `+91 ${restOfNumber}`;
                              } else if (phoneNumber.startsWith("+1")) {
                                const restOfNumber = phoneNumber
                                  .substring(2)
                                  .replace(/\s+/g, "");
                                return `+1 ${restOfNumber}`;
                              } else if (phoneNumber.match(/^\+\d{2}/)) {
                                const countryCode = phoneNumber.substring(0, 3);
                                const restOfNumber = phoneNumber
                                  .substring(3)
                                  .replace(/\s+/g, "");
                                return `${countryCode} ${restOfNumber}`;
                              } else if (phoneNumber.match(/^\+\d{3}/)) {
                                const countryCode = phoneNumber.substring(0, 4);
                                const restOfNumber = phoneNumber
                                  .substring(4)
                                  .replace(/\s+/g, "");
                                return `${countryCode} ${restOfNumber}`;
                              }
                              return phoneNumber;
                            } else if (
                              phoneNumber.startsWith("91") &&
                              phoneNumber.length > 10
                            ) {
                              return `+91 ${phoneNumber.substring(2)}`;
                            } else {
                              return `+91 ${phoneNumber}`;
                            }
                          })()}
                    </TableCell>
                    <TableCell>{member?.employee_number || ""}</TableCell>
                    <TableCell>
                      {/* {member?.department_name || ""} */}
                      {`${member?.department_name || ""} - ${
                        member?.roleName || ""
                      }`}
                      <br />
                      <Typography variant="body2" color="textSecondary">
                        {member?.access ? `${member.access} access` : ""}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <span
                        className={
                          member.account_status === "Active"
                            ? classes.active
                            : classes.inactive
                        }
                      >
                        {member?.account_status || ""}
                      </span>
                    </TableCell>
                    <TableCell>
                      {localStorage?.roleName === "Admin" &&
                        (localStorage?.departmentId === "null" ||
                          Number(localStorage?.getItem("departmentId")) ===
                            1) &&
                        // || Number(localStorage?.departmentId) ===
                        //       member?.department_id)
                        featuresAccess?.viewTeamMemberDetails && (
                          <VisibilityIcon
                            fontSize="small"
                            className={classes.multipleLogo}
                            onClick={() => handleDetailView(member)}
                          />
                        )}
                    </TableCell>
                  </TableRow>
                ))
              ) : teamMembersData.status === false ? (
                <TableRow
                  style={{
                    border: "2px solid rgb(255,0,0)",
                    backgroundColor: "rgb(255,240,240)",
                    Opacity: 1,
                    textAlign: "center",
                    padding: "0.8rem",
                    fontSize: "0.875rem",
                  }}
                >
                  <TableCell colSpan={10} align="center">
                    'Something went wrong. Please contact Schrocken support.'
                  </TableCell>
                </TableRow>
              ) : (
                <TableRow>
                  <TableCell colSpan={9} align="center">
                    No records found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </TableContainer>
      <Drawer
        anchor="right"
        open={ViewDetailsDrawer}
        onClose={() => setViewDetailsDrawer(false)}
        classes={{ paper: classes.drawerPaper }}
        // hideBackdrop={true}
      >
        <ViewDetails
          user={user}
          departmentDetails={fetchDepartmentsList}
          ViewDetailsDrawer={ViewDetailsDrawer}
          setViewDetailsDrawer={setViewDetailsDrawer}
          handleRefresh={handleRefresh}
        />
      </Drawer>
      {showPagination === true && (
        // teamMembersListLoading === false &&
        <Box
          style={{
            marginTop: 24,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingRight: "2rem",
          }}
        >
          <IconButton
            disabled={currentPage === 1}
            onClick={() => handlePageChange(currentPage - 1)}
          >
            <ChevronLeft />
          </IconButton>
          <Typography style={{ margin: "0 16px" }}>
            Page {currentPage} of {totalPages}
          </Typography>
          <IconButton
            disabled={currentPage === totalPages}
            onClick={() => handlePageChange(currentPage + 1)}
          >
            <ChevronRight />
          </IconButton>
        </Box>
      )}
    </div>
  );

  return (
    <>
      {/* <BackDropLoading /> */}
      {/* <Dialog open={openDialog} fullScreen> */}

      <Grid
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: "row",
        }}
      >
        <Grid>
          <Typography
            style={{ fontSize: "1rem", marginLeft: "2rem" }}
            variant="h6"
          >
            Details and current status of team members.
          </Typography>
        </Grid>
        <Grid>
          {featuresAccess?.inviteTeamMember && (
            <Button
              startIcon={<AddIcon />}
              onClick={() => {
                setInviteDrawer(true);
                sessionStorage.clear();
              }}
              // onClick={() => {
              //   setOpenUploadDSBatch(true);
              // }}
              className={classes.upload}
            >
              Invite Team Member
            </Button>
          )}
          <Drawer
            anchor="right"
            open={inviteDrawer}
            onClose={() => setInviteDrawer(false)}
            classes={{ paper: classes.drawerPaper }}
          >
            {/* <CreateNewRole setOpen={setOpen} departmentAPI={departmentAPI} /> */}
            <InviteTeamMember
              setInviteDrawer={setInviteDrawer}
              departmentDetails={fetchDepartmentsList}
              handleRefresh={handleRefresh}
            />
          </Drawer>
        </Grid>
      </Grid>

      <Grid
        style={{
          paddingLeft: "2rem",
          paddingRight: "2rem",
          paddingTop:
            (featuresAccess?.teamMembersTab &&
              featuresAccess?.invitationSentTab) ||
            featuresAccess?.invitationSentTab ||
            featuresAccess?.teamMembersTab
              ? "2rem"
              : "0rem",
          paddingBottom:
            (featuresAccess?.teamMembersTab &&
              featuresAccess?.invitationSentTab) ||
            featuresAccess?.invitationSentTab ||
            featuresAccess?.teamMembersTab
              ? "2rem"
              : "0rem",
        }}
      >
        <Tabs
          value={view}
          onChange={handleTabChange}
          indicatorColor="secondary"
          textColor="secondary"
          style={{ color: "black" }}
          // style={{ borderBottom: "1px solid #ddd" }}
        >
          {featuresAccess?.teamMembersTab && (
            <Tab
              style={{ color: view === "TeamMembers" ? "#1890ff" : "black" }}
              // label="Team Members"
              label={`Team Members (${totalRecordsOfTeamMembers})`}
              value="TeamMembers"
            />
          )}
          {featuresAccess?.invitationSentTab && (
            <Tab
              style={{ color: view === "InvitationSent" ? "#1890ff" : "black" }}
              // label="Invitation Sent"
              label={`Invitation Sent (${pendingRecords})`}
              value="InvitationSent"
            />
          )}
        </Tabs>
        <Grid item xs={12}>
          {view === "TeamMembers" && renderTeamMemberDetails()}
          {view === "InvitationSent" && (
            <InvitationSent
              teamMembersList={teamMembersList}
              // handleRoleChange={handleRoleChange}
              // roleOptions={roleOptions}
              teamMembersListLoading={teamMembersListLoading}
              fetchDepartmentsList={fetchDepartmentsList}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default TeamDashboard;
